import React, { useEffect, useState } from "react";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import { GoPlusCircle } from "react-icons/go";

import { Tooltip } from "@mui/material";
import { IoDocumentTextOutline } from "react-icons/io5";

import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { Button, Divider, Dropdown, Skeleton, Tag } from "antd";

import { PiHamburger, PiHamburgerLight } from "react-icons/pi";

import { LiaTrainSolid } from "react-icons/lia";
import moment from "moment";
import KochaHeader from "./KochaHeader";

export default function Kocha() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessage();

  let getSolds = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get("/api/kocha");
      if (data.success) {
        console.log("data");
        console.log(data);
        setData(data.data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSolds();
  }, []);

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar"
        >
          <LiaTrainSolid className="font-[30px]" /> Vagonlar
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar/new"
        >
          <GoPlusCircle className="font-[30px]" /> Vagon
        </Link>
      ),
    },
    // {
    //   key: "6",
    //   label: (
    //     <Link
    //       className=" block w-[100%] flex items-center justify-start gap-1"
    //       rel="noopener noreferrer"
    //       to="/"
    //     >
    //       <MdOutlineCalculate className="font-[30px]" /> Jami
    //     </Link>
    //   ),
    // },
  ];

  // loading
  if (loading) {
    return (
      <div className="pb-[50px]">
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <h2 className="bold text-[20px]">Yukxalari</h2>

          <div className="flex gap-1">
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <PiHamburger />
              </Button>
            </Dropdown>
          </div>
        </div>

        <div className="w-[100%] flex flex-col items-start md:gap-2 overflow-auto">
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
        </div>
      </div>
    );
  }

  if (data?.data?.length == 0 || !data) {
    return (
      <div>
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <h2 className="bold text-[20px]">Yukxalari</h2>

          <div className="flex gap-1">
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <PiHamburgerLight />
              </Button>
            </Dropdown>
          </div>
        </div>
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
                <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                  Page not found
                </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Yukxati mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/kocha/vagonlar/new"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Vagon qo'shish
              </Link>
              <Link to="/vagonlar" class="text-sm font-semibold text-gray-900">
                Vagonlar <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <KochaHeader />

      <div className="pb-[70px] w-[100%] overflow-auto max-w-[900px] m-auto flex flex-col items-start">
        <div className="w-[100%]  flex flex-col items-center gap-1 ">
          {data?.unconfirmed?.map((el) => {
            console.log(el);
            return (
              <Link
                to={"/kocha/" + el.nakladnoy_id}
                onContextMenu={(e) => {
                  e.preventDefault();
                  console.log(e);
                }}
                className={
                  " w-[100%] py-2  text-[#e11d48] text-bold p-1 cursor-pointer  border-[1px] border-[#bfbfbf36] hover:text-[#e11d48] "
                }
              >
                <div className="flex flex-row items-center justify-between">
                  <p
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    className=" text-[18px] md:text-[14px] text-[#111827] p-0 m-0  md:col-span-2"
                  >
                    {el.id}- {el.name}
                  </p>
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={`yaratildi: ${el?.date} \n updated: ${el?.updated_at}`}
                    >
                      {moment(el.date).format("DD.MM.YYYY")}
                    </Tooltip>
                  </p>
                </div>
                <div className="flex flex-row items-center justify-between pl-2">
                  <h2
                    className="text-[14px] text-[#6b7280] p-0 m-0"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {el?.products_data?.map((val) => {
                      return val?.name + " : " + val?.tonna;
                    })}
                  </h2>

                  <p className="m-0 p-0 italic text-[15px] bold">
                    #{el?.status}
                  </p>
                </div>
                {/* <p className="text-[14px] text-[#6b7280]  p-0 m-0">{el.INN}</p> */}
              </Link>
            );
          })}
          <Divider orientation="left">Tasdiqlanganlar</Divider>
          {data?.confirmed?.map((el, i) => {
            console.log(el);
            return (
              <>
                {data?.confirmed[i - 1]?.date?.split("T")[0] ==
                data?.confirmed[i]?.date?.split("T")[0] ? null : (
                  <Divider orientation="center" className="mx-1">
                    {data?.confirmed[i].date?.split("T")[0]}
                  </Divider>
                )}
                <Link
                  to={"/kocha/" + el.nakladnoy_id}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    console.log(e);
                  }}
                  className={
                    "shrink-0 max-w-[900px] w-[100%]  py-2 text-stone-900 text-bold p-1    bg-[#d1fae5] cursor-pointer  border-[1px] border-[#bfbfbf36] hover:text-[#10b981] "
                  }
                >
                  <div className="flex flex-row items-center justify-between">
                    <p
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      className="text-[18px] md:text-[14px] text-[#111827] p-0 m-0  md:col-span-2"
                    >
                      {el.id}- {el.name}
                    </p>
                    <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                      <Tooltip
                        sx={{ fontSize: "10px" }}
                        className="text-[14px]"
                        title={`yaratildi: ${el?.date} \n updated: ${el?.updated_at}`}
                      >
                        {moment(el.date).format("DD.MM.YYYY")}
                      </Tooltip>
                    </p>
                  </div>
                  <div className="flex flex-row items-center justify-between pl-2">
                    <h2
                      className="text-[14px] text-[#6b7280] p-0 m-0"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {el?.products_data?.map((val) => {
                        return val?.name + " : " + val?.tonna;
                      })}
                    </h2>

                    <p className="m-0 p-0 italic text-[15px] bold">
                      #{el?.status}
                    </p>
                  </div>
                </Link>{" "}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
